<i class="k-icon k-font-icon k-i-close dialog-close" (click)="onClose()"></i>
<div class="wrapper">
  <div *ngIf="!submitted">
    <div class="dialog-title">Send Us Feedback</div>
    <p>
      Use this form to provide feedback to the Intel 471 Research Team about any
      issues with the Hunt Packages, Content, or Threat Intelligence information
      presented. Screen reader support enabled.
      <br /><br />
      For any other type of support or feedback, please visit our
      <a routerLink="/customer-support">Support</a> page.
    </p>
    <form [formGroup]="feedbackForm" (ngSubmit)="onSendFeedBack()">
      <kendo-formfield [orientation]="'horizontal'">
        <ul class="k-radio-list k-list-horizontal pt-2">
          <li class="k-radio-item" *ngFor="let type of feedbackTypes">
            <kendo-label class="k-radio-label" text="{{ type }}">
              <input
                type="radio"
                [value]="type"
                kendoRadioButton
                formControlName="feedbackType"
              />
            </kendo-label>
          </li>
        </ul>
      </kendo-formfield>
      <p>{{ feedbackExplanations[this.feedbackForm.value.feedbackType] }}</p>
      <div class="row">
        <div class="col-12">
          <cyborg-error *ngIf="error" [error]="error"></cyborg-error>
        </div>
        <div class="col-12">
          <label>Message</label>
          <textarea formControlName="message"></textarea>
        </div>
      </div>
      <button
        themeColor="primary"
        size="large"
        type="submit"
        [disabled]="!feedbackForm.valid"
        kendoButton
      >
        Submit
      </button>
    </form>
  </div>
  <div *ngIf="submitted" class="submitted">
    <div class="dialog-title">Your Message has been sent!</div>
    <p>The Intel 471 Support Team will respond shortly.</p>
    <button themeColor="primary" size="large" (click)="onClose()" kendoButton>
      Close
    </button>
  </div>
</div>
